<template>
	<div class="">
		<base-page-heading
			title="Pages Background"
			subtitle=""
			class="d-print-none"
		>
			<template #extra>
				<b-button
					ref="pagebgShow"
					type="submit"
					size="md"
					variant="secondary"
					@click="showModal"
				>
					<i class="fa fa-fw fa-plus" /> 	Create new
				</b-button>
			</template>
		</base-page-heading>

		<div class="row">
			<PageBgTable
				@routePagebg="routePagebg"
			/>
		</div>
	</div>
</template>
